import { Modal, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

export const BankConnectionRemovalModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: bank connection removal modal - title",
        defaultMessage: "Sorry, removing this is not possible",
      })}
      primaryAction={{
        onAction: closeModal,
        content: intl.formatMessage({
          id: "funding-application: bank connection removal modal - okay",
          defaultMessage: "Okay",
        }),
      }}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <TextContainer>
        <Text>
          {intl.formatMessage({
            id: "funding-application: bank connection removal modal - can not remove (generic)",
            defaultMessage:
              "You must connect at least one bank account before proceeding. We use this to help us understand your business's financial health.",
          })}
        </Text>
        <Text>
          {intl.formatMessage({
            id: "funding-application: bank connection removal modal - chat to us message",
            defaultMessage:
              "If you need help, chat to us using the link on this page or reach out to your Wayflyer representative directly if you have one.",
          })}
        </Text>
      </TextContainer>
    </Modal>
  );
};
